// Alertify notification plugin for Firebase notifications
export default {
  success({ title, message, onClick }) {
    // You can replace this with your preferred notification library
    // For now, using browser notifications
    if ('Notification' in window && Notification.permission === 'granted') {
      const notification = new Notification(title, {
        body: message,
        icon: '/src/assets/images/logo/vesproc120.png'
      });
      
      if (onClick) {
        notification.onclick = onClick;
      }
    }
    
    // Also log to console for debugging
    console.log(`✅ ${title}: ${message}`);
  },
  
  warning({ title, message, onClick }) {
    if ('Notification' in window && Notification.permission === 'granted') {
      const notification = new Notification(title, {
        body: message,
        icon: '/src/assets/images/logo/vesproc120.png'
      });
      
      if (onClick) {
        notification.onclick = onClick;
      }
    }
    
    console.log(`⚠️ ${title}: ${message}`);
  },
  
  error({ title, message, onClick }) {
    if ('Notification' in window && Notification.permission === 'granted') {
      const notification = new Notification(title, {
        body: message,
        icon: '/src/assets/images/logo/vesproc120.png'
      });
      
      if (onClick) {
        notification.onclick = onClick;
      }
    }
    
    console.log(`❌ ${title}: ${message}`);
  }
};
